import types from '../types';
import baseUrl from '../baseUrl';

const GetVendorPricing = (vendorId) => ({
    type: types.GET_VENDOR_PRICING,
    payload: {},
    meta: {
        type: 'apijson',
        url: `${baseUrl}/vendorPricing/${vendorId}`,
    },
    options: {
        method: 'GET'
    }
})

export default GetVendorPricing;
